import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PersonalDetailsFormErrorStatesEnum {
    GetIndividualFailed = ErrorStateScheduleEnum.PersonalDetailsFormStatesStartIndex,
    UpdateIndividualFailed,
    CreateIndividualFailed
}
